import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { billingApi } from "@/lib/api";

export function PaymentSuccess() {
  const [qs] = useSearchParams();
  const sid = qs.get("session_id");
  const [st, setSt] = useState(null);
  useEffect(() => {
    let n = 0; let stop = false;
    const tick = async () => {
      try { const r = await billingApi.status(sid); setSt(r); if (r.payment_status === "paid" || r.status === "expired") return; } catch (e) { setSt({ status: "error" }); return; }
      if (!stop && ++n < 30) setTimeout(tick, 2000); else setSt((x) => ({ ...x, timeout: true }));
    };
    if (sid) tick();
    return () => { stop = true; };
  }, [sid]);
  const paid = st?.payment_status === "paid";
  return (
    <div data-testid="payment-success-page" className="grid min-h-screen place-items-center bg-[#07060b] px-6 text-white">
      <div className="glass-strong max-w-md rounded-3xl p-8 text-center">
        {paid ? <CheckCircle2 className="mx-auto h-12 w-12 text-[#6fd6b0]" /> : <Loader2 className="mx-auto h-12 w-12 animate-spin text-[#a78bff]" />}
        <h1 data-testid="payment-status-title" className="mt-4 font-display text-3xl font-bold">{paid ? "Payment confirmed" : st?.timeout ? "Still confirming…" : "Confirming payment…"}</h1>
        <p data-testid="payment-status-detail" className="mt-2 text-sm text-white/60">
          {paid ? (st.kind === "topup" ? "Your usage wallet has been credited." : `Your ${st.plan} plan is active.`) : st?.timeout ? "Stripe hasn't confirmed yet. This page doesn't advance until payment is confirmed — check Billing in a minute." : "Waiting for Stripe to confirm the payment."}
        </p>
        <Link to="/app/billing" data-testid="payment-go-billing" className="mt-6 inline-block rounded-full bg-fire px-5 py-2 text-sm font-semibold">Go to Billing</Link>
      </div>
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div data-testid="payment-cancel-page" className="grid min-h-screen place-items-center bg-[#07060b] px-6 text-white">
      <div className="glass-strong max-w-md rounded-3xl p-8 text-center">
        <XCircle className="mx-auto h-12 w-12 text-[#ff5c7a]" />
        <h1 className="mt-4 font-display text-3xl font-bold">Checkout cancelled</h1>
        <p className="mt-2 text-sm text-white/60">No charge was made.</p>
        <Link to="/app/billing" className="mt-6 inline-block rounded-full border border-white/15 px-5 py-2 text-sm">Back to Billing</Link>
      </div>
    </div>
  );
}
